import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CouponModel } from '@shared/models/CouponModel';
import { AssignedStickerType } from '@shared/models/Enums';

@Component({
    selector: 'app-assigned-sticker',
    templateUrl: './assigned-sticker.component.html',
    styleUrls: ['./assigned-sticker.component.scss']
})
export class AssignedStickerComponent implements OnInit {

    @Input() assignedStickerType: AssignedStickerType = AssignedStickerType.Sticker;
    @Input() assignedCoupon: CouponModel = null;
    @Output() closeSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();

    progress = 0;

    constructor() { }

    ngOnInit(): void {
        this.startProgress();
    }
    
    onClose(){

        this.closeSuccess.emit();
    }

    startProgress() {

        const interval = 100; // update each
        const duration = 5000; // duration

        setTimeout(()=>this.closeSuccess.emit(), 6000)
        
        const step = (interval / duration) * 100;
    
        const timer = setInterval(() => {
            
        this.progress += step;

        if (this.progress >= 100) {
            
            clearInterval(timer);
        }

    }, interval);
    }

}
